import { PatientAppBar } from '@psyomics/ui-components';
import { Outlet } from 'react-router-dom';

import { HeaderIllustrationLayout } from '../../../shared/components/header-illustration-layout/header-illustration-layout';
import { usePatientAppBarContext } from '../../contexts/patient-app-bar';

const InsecureLayout = () => {
  const { showUrgentHelp, setShowUrgentHelp, withIllustration } = usePatientAppBarContext();

  return (
    <div className="flex flex-col">
      <header>
        <PatientAppBar
          hideIcon
          onShowUrgentHelpDialogChange={setShowUrgentHelp}
          showUrgentHelpDialog={showUrgentHelp}
        />
      </header>
      <main className="flex-grow">{withIllustration ? <HeaderIllustrationLayout /> : <Outlet />}</main>
    </div>
  );
};

export { InsecureLayout };
